import React from "react";
import { clearTokens } from "./tokens";
import { logoutUser } from "../redux/modules/userSlice";
import { useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import { queryClient } from "../query/queryClient";

export default function Logout() {
  const dispatch = useDispatch();

  clearTokens();
  queryClient.clear();
  dispatch(logoutUser());

  // Перевіряємо, чи користувач раніше реєструвався/входив
  const hasRegisteredOrLoggedIn = localStorage.getItem("hasRegisteredOrLoggedIn");
  if (hasRegisteredOrLoggedIn === "true") {
    return <Redirect to="/login" />;
  } else {
    return <Redirect to="/register" />;
  }
}
